import { AxiosError } from 'axios';

import { BaseApiError } from 'src/errors';

const IGNOREED_REQUESTS_URL_BY_SENTRY: string[] = ['/validate'];

export const shouldWeSendThisErrorToSentry = (error: unknown): boolean => {
  if (error instanceof AxiosError) {
    if (error.request instanceof XMLHttpRequest) {
      for (const url of IGNOREED_REQUESTS_URL_BY_SENTRY) {
        if (error.request.responseURL.includes(url)) {
          return false;
        }
      }
    }
  }
  if (error instanceof BaseApiError && error.axiosError) {
    const axiosError = error.axiosError;
    if (axiosError instanceof XMLHttpRequest) {
      for (const url of IGNOREED_REQUESTS_URL_BY_SENTRY) {
        if (axiosError.responseURL.includes(url)) {
          return false;
        }
      }
    }
  }
  return true;
};
